import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutonumericModule } from 'src/app/project/directives/autonumeric/autonumeric.module';
import { TimeInputComponent } from './time-input.component';

@NgModule({
  declarations: [TimeInputComponent],
  imports: [CommonModule, FormsModule, AutonumericModule],
  exports: [TimeInputComponent],
})
export class TimeInputModule {}
